/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export enum DomainRecruiterNewDriverStatusEnum {
  'RecruiterNewDriverStatusNew' = 'new',
  'RecruiterNewDriverStatusNotified' = 'notified',
  'RecruiterNewDriverStatusConfirmed' = 'confirmed',
  'RecruiterNewDriverStatusDeclined' = 'declined',
  'RecruiterNewDriverStatusCanceled' = 'canceled',
  'RecruiterNewDriverStatusError' = 'error',
}

export type DomainRecruiterNewDriverStatus = DomainRecruiterNewDriverStatusEnum